import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const PPMobileCardView = ({ title, id, rows, menuItems, children }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <div className="pp-card">
            <div className="pp-card-header">
                <div>
                    {id && <span className="pp-card-id"> #{id}</span>}
                    <span className="pp-card-title">{title}</span>
                </div>
                {menuItems && (
                    <IconButton size="small" onClick={handleOpen} style={{ padding: 2 }}>
                        <MoreVertIcon fontSize="small" />
                    </IconButton>
                )}
            </div>
            <div className="pp-card-grid">
                {rows.map((row, i) => (
                    <div className="pp-card-cell" key={i}>
                        <div className="pp-card-label">{row.label}</div>
                        <div className="pp-card-value">{row.value}</div>
                    </div>
                ))}
            </div>
            {children}
            {menuItems && (
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {menuItems.map((item, i) => (
                        <MenuItem key={i} onClick={() => { handleClose(); item.onClick(); }}>
                            {item.label}
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </div>
    );
};

export default PPMobileCardView;
